module.exports = __webpack_public_path__ + "static/monika_proba@x2-8e417e4288b79b1e808918c1ce388ffa.jpg";